import hemicycle from '../graph/hemicycle';

let graphData = {};

function getPreviousPartiesByBlocks(currentParties, previousParties) {
  let parties = [];
  const difference = previousParties
    .filter((e) => !currentParties
      .find((a) => e.partyCode === a.partyCode));

  currentParties.forEach((current) => {
    const foundElement = previousParties
      .find((previous) => current.partyCode === previous.partyCode);

    if (foundElement) {
      parties.push(foundElement);
    }
  });

  if (difference.length > 0) {
    parties = parties.concat(difference.filter((party) => party.seats !== 0));
  }

  return parties;
}

function drawChart(byBlocks = false) {
  const {
    validCurrentParties,
    validPreviousParties,
    validPreviousPartiesByBlocks,
    seats,
  } = graphData;

  const previousParties = byBlocks ? validPreviousPartiesByBlocks : validPreviousParties;
  const currentParties = validCurrentParties.map((p) => {
    const match = previousParties.find((p1) => p1.partyCode === p.partyCode);

    return { ...p, prevSeats: match ? match.seats : 0 };
  });

  hemicycle.init('ac-hemicycle', currentParties, previousParties, seats);
}

function addEvents() {
  if (document.querySelector('.js-change-order')) {
    document.querySelector('.js-change-order').addEventListener('click', (e) => drawChart(e.currentTarget.checked));
  }
}

function setIntialView() {
  window.dataManager.getGenerales().then((generales) => {
    if (generales.parties) {
      window.dataManager.getHistoricParties().then((previousParties) => {
        const { seats } = generales.voting;
        const validPreviousParties = previousParties.filter((party) => party.seats !== 0);
        let validCurrentParties = generales.parties.filter((party) => party.seats !== 0);
        validCurrentParties = validCurrentParties
          .sort((a, b) => (a.seats === b.seats ? b.votes - a.votes : b.seats - a.seats));

        const validPreviousPartiesByBlocks = getPreviousPartiesByBlocks(
          validCurrentParties,
          validPreviousParties,
        );

        if (document.querySelector('.ac-hemicycle_escanios')) {
          document.querySelector('.ac-hemicycle_escanios').innerHTML = seats;
        }

        if (document.querySelector('.ac-hemicycle_escanios_mayoria')) {
          document.querySelector('.ac-hemicycle_escanios_mayoria').innerHTML = Math.floor(seats / 2) + 1;
        }

        graphData = {
          validCurrentParties,
          validPreviousParties,
          validPreviousPartiesByBlocks,
          seats,
        };

        drawChart();
        addEvents();
      });
    }
  });
}

function init() {
  if (document.querySelector('[data-controller*="ac-hemicycle"]')) {
    setIntialView();
  }
}

export default init;
